export default __webpack_public_path__ + "media/images/46-d7537ed86093484e5dcdd9d0afbb4212.png";